export default __webpack_public_path__ + "static/media/celsius_logo.c9faaaf6.svg";